const calculateId = 'ss-metric--calc-button';
const resetId = 'ss-metric--reset-button';
const downloadId = 'ss-metric--download-button';
const paginationId = 'ss-metric--pagination-item';

export {
    calculateId,
    resetId,
    downloadId,
    paginationId
}
